<div class="collapsibleMenuContainer" [ngClass]="positionClasses" [class.disabled]="disabled()">
    <span (click)="!disabled() && openMenu($event)" class="menuActivator">
        <ng-content select="[menuActivator]" />
    </span>

    @if (menuOpen()) {
        <div class="collapsibleMenu" #collapsibleMenu [hidden]="menuActivatorReference && hidden" (clickOutside)="closeMenu()">
            <ng-content />
        </div>
    }
</div>
